import React from 'react';
import { Box, Link } from "~/native-ui"

import style from './media-item.css';

const MyNavigation = ({ data, ...props}) => (
    <Box flexDirection='row' {...props}>
        {data.map((element, index) =>
            <Link
                px={1}
                key={element.label + index}
                href={element.href}
                label={element.label}
                active={element.active}
                isUnderlined={false}
                data-highlight={element.active ? "" : "muted"}
                className={element.separator ? style.separator : ''}
                onClick={!element.separator ? props.handleClick.bind(this, ...element.clickArgs) : () => '' }
            />
        )}
    </Box>
);

MyNavigation.defaultProps = {
    data: [
        {
            label: 'Home',
            href: '',
            clickArgs: []
        },
        {
            label: '>',
            separator: true,
            clickArgs: []
        },
        {
            label: 'Customer',
            href: '',
            active: true,
            clickArgs: []
        }
    ],
    handleClick: () => console.log('Navigation not set click function')
};

export default MyNavigation;
